<div class="header_search">
  <div class="title-page">
    <h3>Cronograma {{isProjeto ? 'do Projeto': ''}}</h3>
  </div>
</div>

<div class="system-table table-container system-table-m-b">
  <div class="system-table-conteiner">
    <table>
      <thead>
        <tr>
          <th class="text-center">Resumo Monitoramento</th>
          <th class="text-center">Percentual Execução</th>
          <th class="text-center">Percentual Previsto de Execução</th>
          <th class="text-center">Conclusão Cronograma</th>
          <th class="text-center">Conclusão<br>Linha de Base</th>
          <th class="text-center">Dias de Atraso</th>
          <th class="text-center">Atualização</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="title status text-center" >
            <span class="d-grid" *ngIf="cronograma?.end_baseline">
              <span class="font-icon-fill dot" [class]="cronograma?.status?.icon == 'check_circle_unread'? 'font-icon-status':''" [style]="{'color': cronograma?.status?.color}">{{cronograma?.status?.icon}}</span>
              {{cronograma?.status?.label}}
            </span>
          </td>
          <td class="text-center">{{cronograma?.progress}}</td>
          <td class="text-center">{{cronograma?.foreseen_executed ? (cronograma?.foreseen_executed | number:'1.0-0') : 0}}</td>
          <td class="text-center">{{cronograma?.end| date: 'dd/MM/yyyy':'UTC' }}</td>
          <td class="text-center">{{cronograma?.end_baseline| date: 'dd/MM/yyyy':'UTC' }}</td>
          <td class="text-center">{{cronograma?.days_late}}</td>
          <td class="text-center">{{cronograma?.ctr_dth_atu| date: 'dd/MM/yyyy':'UTC' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<app-historico-atualizacoes-list [audit]="audit"></app-historico-atualizacoes-list>
<app-loading [loader]="isLoading"></app-loading>